export default __webpack_public_path__ + "static/media/upload.9f22fe07.mp4";